export function showInfo(pmsModuleName, fieldName) {
  const infoConditions = {
    Timon: ['address'],
    Winhotel: ['name', 'surname', 'second_surname', 'address'],
    Sihot360: ['province'],
    GuestPortal: ['name', 'surname', 'second_surname', 'province'],
    Ohip: ['address'],
    Noray_htl: ['province'],
  };

  return infoConditions[pmsModuleName]?.includes(fieldName) ?? false;
}

export function showWarning(fieldName) {
  const warningConditions = ['family_relationship', 'document_support_number', 'province', 'city'];

  return warningConditions?.includes(fieldName) ?? false;
}
